import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'

pdfMake.vfs = pdfFonts
pdfMake.fonts = {
    THSarabunNew: {
        normal: 'https://cdn.jsdelivr.net/npm/font-th-sarabun-new@1.0.0/fonts/THSarabunNew-webfont.ttf',
        bold: 'https://cdn.jsdelivr.net/npm/font-th-sarabun-new@1.0.0/fonts/THSarabunNew_bold-webfont.ttf',
        italics: 'https://cdn.jsdelivr.net/npm/font-th-sarabun-new@1.0.0/fonts/THSarabunNew_italic-webfont.ttf',
        bolditalics: 'https://cdn.jsdelivr.net/npm/font-th-sarabun-new@1.0.0/fonts/THSarabunNew_bolditalic-webfont.ttf'
    },
    Roboto: {
        normal: 'Roboto-Regular.ttf',
        bold: 'Roboto-Medium.ttf',
        italics: 'Roboto-Italic.ttf',
        bolditalics: 'Roboto-MediumItalic.ttf'
    }
}

const DEFAULTS = {
    isShowTicket: false,
    schoolName: '',
    schoolNameEng: '',
    documentTitle: '',
    enrollmentGrade: '',
    registrationStartDate: '',
    registrationEndDate: '',
    academicYear: '',
    studentName: '',
    lastName: '',
    studentPhoto: null,
    birthDate: '',
    birthMonth: '',
    birthYear: '',
    age: '',
    nationality: '',
    ethnicity: '',
    religion: '',
    idNumber: '',
    houseNumber: '',
    moo: '',
    soi: '',
    road: '',
    tambon: '',
    amphoe: '',
    province: '',
    postalCode: '',
    phone: '',
    currentGrade: '',
    currentYear: '',
    previousSchool: '',
    previousAmphoe: '',
    previousProvince: '',
    fatherName: '',
    fatherLastName: '',
    fatherOccupation: '',
    fatherPosition: '',
    fatherPhone: '',
    fatherWorkplace: '',
    motherName: '',
    motherLastName: '',
    motherOccupation: '',
    motherPosition: '',
    motherPhone: '',
    motherWorkplace: '',
    parentsStatus: '',
    hasSibling: false,
    siblingName: '',
    siblingLastName: '',
    siblingGrade: '',
    siblingHouse: '',
    applicationDate: '',
    applicationMonth: '',
    applicationYear: '',
    applicationNumber: '',
    examGrade: '',
    examGradeLevel: '',
    examYear: '',
    examDate: '',
    examTime: '',
    examRoom: '',
    examNumber: '',
    checkDoc1: false,
    checkDoc2: false,
    checkDoc3: false,
    checkDoc4: false,
    checkDoc5: false,
    checkDoc6: false,
    schoolFonSize: null,
}

export function generateEnrollmentFormPDF(data) {
    const mergedData = { ...DEFAULTS, ...data }

    // Helper function to create checkbox with checkmark
    const createCheckbox = (isChecked, mt = 0) => ({
        stack: [
            {
                canvas: [
                    { type: 'rect', x: 0, y: 0, w: 8, h: 8, lineWidth: 1 },
                    ...(isChecked
                        ? [
                              {
                                  type: 'polyline',
                                  lineWidth: 1.5,
                                  closePath: false,
                                  points: [
                                      { x: 1.5, y: 4 },
                                      { x: 3, y: 6.5 },
                                      { x: 6.5, y: 1.5 }
                                  ]
                              }
                          ]
                        : [])
                ]
            }
        ],
        margin: [0, mt, 0, 0],
        width: 8
    })

    // Helper function to create input field with dashed underline
    const createField = (value, width, alignment = 'center', fontSize = null, margin = null) => ({
        stack: [
            {
                margin: margin,
                text: value || '\u00A0',
                style: 'fieldData',
                alignment,
                ...(fontSize && { fontSize })
            },
            {
                canvas: [
                    {
                        type: 'line',
                        x1: 0,
                        y1: 0,
                        x2: width,
                        y2: 0,
                        dash: { length: 1, space: 2 },
                        lineWidth: 1
                    }
                ],
                margin: [0, -3, 0, 0]
            }
        ],
        width
    })

    const documentDefinition = {
        pageSize: 'A4',
        pageMargins: [30, 30, 30, 30],
        defaultStyle: {
            font: 'THSarabunNew',
            fontSize: 14
        },

        content: [
            // Header with logo and school info
            {
                columns: [
                    {
                        width: '100%',
                        stack: [
                            {
                                columns: [
                                    {
                                        text: `${mergedData.documentTitle}`,
                                        style: 'documentTitle',
                                        width: 'auto'
                                    },
                                    createField(mergedData.enrollmentGrade, 30, 'center')
                                ],
                                alignment: 'center',
                                margin: [130, 5, 0, 0]
                            },
                            {
                                text: `${mergedData.schoolName}`,
                                style: 'schoolName',
                                alignment: 'center'
                            },
                            {
                                columns: [
                                    {
                                        text: 'เปิดรับสมัครสอบวันที่ ',
                                        style: 'schoolName',
                                        alignment: 'right',
                                        width: 255
                                    },
                                    createField(mergedData.registrationStartDate, 70, 'center'),
                                    { text: '-', style: 'schoolName', width: 8, margin: [0, -2, 0, 0] },
                                    createField(mergedData.registrationEndDate, 70, 'center')
                                ],
                                alignment: 'center'
                            }
                        ]
                    }
                ],
                margin: [0, 0, 0, 5]
            },

            // Student photo placeholder
            ...(mergedData.studentPhoto && mergedData.isShowTicket
                ? [
                    {
                        image: mergedData.studentPhoto,
                        width: 70,
                        height: 80,
                        absolutePosition: { x: 500, y: 20 }
                    }
                    ]
                :   [
                    {
                        canvas: [
                            {
                                type: 'rect',
                                x: 0,
                                y: 0,
                                w: 70,
                                h: 80,
                                lineWidth: 1,
                                lineColor: 'black',
                                color: '#ffffff'
                            }
                        ],
                        absolutePosition: { x: 500, y: 20 }
                    }
                    ]),

            // Form number and date
            {
                columns: [
                    {
                        width: '50%',
                        columns: [
                            { text: 'สมัครวันที่ ', style: 'formInfo', width: 'auto' },
                            createField(mergedData.applicationDate, 30, 'center'),
                            { text: ' เดือน ', style: 'formInfo', width: 'auto' },
                            createField(mergedData.applicationMonth, 70, 'center'),
                            { text: ' พ.ศ. ', style: 'formInfo', width: 'auto' },
                            createField(mergedData.applicationYear, 40, 'center')
                        ]
                    },
                    {
                        width: '50%',
                        columns: [
                            { text: 'เลขประจำตัวผู้สมัคร ', style: 'formInfo' },
                            createField(mergedData.applicationNumber, 100, 'center')
                        ],
                        alignment: 'right'
                    }
                ]
            },

            {
                text: '_______________________________________________________________________',
                margin: [0, -22, 0, 0]
            },

            // Section 1: Personal Information
            {
                text: '1. ประวัติส่วนตัว',
                style: 'sectionHeader',
                margin: [0, 0, 0, -1]
            },

            // Personal details
            {
                columns: [
                    { text: '1.1 ชื่อผู้สมัคร ', style: 'label', width: 'auto' },
                    createField(mergedData.studentName, 135, 'center'),
                    { text: ' นามสกุล ', style: 'label', width: 'auto' },
                    createField(mergedData.lastName, 135, 'center'),
                    { text: ' เลขบัตรประชาชน ', style: 'label', width: 'auto' },
                    createField(mergedData.idNumber, 87, 'center')
                ],
                margin: [12, 0, 0, -1]
            },

            {
                columns: [
                    { text: '1.2 เกิดวันที่ ', style: 'label', width: 'auto' },
                    createField(mergedData.birthDate, 45, 'center'),
                    { text: ' เดือน ', style: 'label', width: 'auto' },
                    createField(mergedData.birthMonth, 125, 'center'),
                    { text: ' พ.ศ. ', style: 'label', width: 'auto' },
                    createField(mergedData.birthYear, 50, 'center'),
                    { text: ' อายุ ', style: 'label', width: 'auto' },
                    createField(mergedData.age, 36, 'center'),
                    { text: ' ปี ', style: 'label', width: 'auto', margin: [0, 0, 2, 0] },
                    { text: ' เชื้อชาติ ', style: 'label', width: 'auto' },
                    createField(mergedData.ethnicity, 120, 'center')
                ],
                margin: [12, 0, 0, -1]
            },

            {
                columns: [
                    { text: 'สัญชาติ ', style: 'label', width: 'auto' },
                    createField(mergedData.nationality, 120, 'center'),
                    { text: ' ศาสนา ', style: 'label', width: 'auto' },
                    createField(mergedData.religion, 120, 'center')
                ],
                margin: [28, 0, 0, -1]
            },

            {
                columns: [
                    { text: '1.3 ที่อยู่ปัจจุบัน บ้านเลขที่ ', style: 'label', width: 'auto' },
                    createField(mergedData.houseNumber, 80, 'center'),
                    { text: ' หมู่ที่ ', style: 'label', width: 'auto' },
                    createField(mergedData.moo, 30, 'center'),
                    { text: ' ซอย/ตรอก ', style: 'label', width: 'auto' },
                    createField(mergedData.soi, 110, 'center'),
                    { text: ' ถนน ', style: 'label', width: 'auto' },
                    createField(mergedData.road, 110, 'center')
                ],
                margin: [12, 0, 0, -1]
            },

            {
                columns: [
                    { text: 'ตำบล/แขวง ', style: 'label', width: 'auto' },
                    createField(mergedData.tambon, 93, 'center'),
                    { text: ' อำเภอ/เขต ', style: 'label', width: 'auto' },
                    createField(mergedData.amphoe, 93, 'center'),
                    { text: ' จังหวัด ', style: 'label', width: 'auto' },
                    createField(mergedData.province, 93, 'center'),
                    { text: ' รหัสไปรษณีย์ ', style: 'label', width: 'auto' },
                    createField(mergedData.postalCode, 50, 'center')
                ],
                margin: [28, 0, 0, -1]
            },

            {
                columns: [
                    { text: 'เบอร์โทรศัพท์ ', style: 'label', width: 'auto' },
                    createField(mergedData.phone, 90, 'center'),
                ],
                margin: [28, 0, 0, -5]
            },

            // Section 2: Educational Background
            {
                text: '2. ประวัติการศึกษา',
                style: 'sectionHeader',
                margin: [0, 0, 0, -1]
            },

            {
                columns: [
                    {
                        text: 'ก่อนสมัครเข้าสอบโรงเรียน ภ.ป.ร. ราชวิทยาลัย ในพระบรมราชูปถัมภ์ กำลังศึกษาอยู่ชั้นประถมศึกษาปีที่',
                        style: 'label',
                        width: 'auto'
                    },
                    createField(mergedData.currentGrade, 20),
                    { text: ' ปีการศึกษา', style: 'label', width: 'auto' },
                    createField(mergedData.currentYear, 40)
                ],
                margin: [12, 0, 0, -1]
            },

            {
                columns: [
                    { text: 'จากโรงเรียน ', style: 'label', width: 'auto' },
                    createField(mergedData.previousSchool, 195, 'center', mergedData.schoolFonSize),
                    { text: ' อำเภอ/เขต ', style: 'label', width: 'auto' },
                    createField(mergedData.previousAmphoe, 100),
                    { text: ' จังหวัด ', style: 'label', width: 'auto' },
                    createField(mergedData.previousProvince, 100)
                ],
                margin: [12, 0, 0, -1]
            },

            // Section 3: Family Information
            {
                text: '3. ประวัติครอบครัว',
                style: 'sectionHeader',
                margin: [0, 0, 0, -1]
            },

            {
                columns: [
                    { text: '3.1 ชื่อบิดา ', style: 'label', width: 'auto' },
                    createField(mergedData.fatherName, 115, 'center'),
                    { text: ' นามสกุล ', style: 'label', width: 'auto' },
                    createField(mergedData.fatherLastName, 105, 'center'),
                    { text: ' อาชีพ ', style: 'label', width: 'auto' },
                    createField(mergedData.fatherOccupation, 90, 'center'),
                    { text: ' โทรศัพท์ ', style: 'label', width: 'auto' },
                    createField(mergedData.fatherPhone, 70, 'center')
                ],
                margin: [12, 0, 0, -1]
            },

            {
                columns: [
                    { text: 'ที่ทำงาน ', style: 'label', width: 'auto' },
                    createField(mergedData.fatherWorkplace, 470, 'left', null, [10, 0, 0, 0])
                ],
                margin: [28, 0, 0, -1]
            },

            {
                columns: [
                    { text: '3.2 ชื่อมารดา ', style: 'label', width: 'auto' },
                    createField(mergedData.motherName, 105, 'center'),
                    { text: ' นามสกุล ', style: 'label', width: 'auto' },
                    createField(mergedData.motherLastName, 105, 'center'),
                    { text: ' อาชีพ ', style: 'label', width: 'auto' },
                    createField(mergedData.motherOccupation, 90, 'center'),
                    { text: ' โทรศัพท์ ', style: 'label', width: 'auto' },
                    createField(mergedData.motherPhone, 70, 'center')
                ],
                margin: [12, 0, 0, 0]
            },

            {
                columns: [
                    { text: 'ที่ทำงาน ', style: 'label', width: 'auto' },
                    createField(mergedData.motherWorkplace, 470, 'left', null, [10, 0, 0, 0])
                ],
                margin: [28, 0, 0, 0]
            },

            // Checkboxes section
            {
                columns: [
                    {
                        width: '28%',
                        stack: [
                            {
                                columns: [
                                    { text: '3.3 บิดา, มารดา ', style: 'label', width: 'auto', margin: [0, 0, 6, 0] },
                                    createCheckbox(mergedData.parentsStatus === 'TOGETHER', 6),
                                    { text: ' อยู่ร่วมกัน', style: 'text', width: 'auto', margin: [3, 0, 0, 0] }
                                ]
                            }
                        ]
                    },
                    {
                        width: '14%',
                        stack: [
                            {
                                columns: [
                                    createCheckbox(mergedData.parentsStatus === 'SEPARATED', 6),
                                    { text: ' แยกกันอยู่', style: 'text', width: 'auto', margin: [3, 0, 0, 0] }
                                ]
                            }
                        ]
                    },
                    {
                        width: '17%',
                        stack: [
                            {
                                columns: [
                                    createCheckbox(mergedData.parentsStatus === 'FATHER_DECEASED', 6),
                                    { text: ' บิดาถึงแก่กรรม', style: 'text', width: 'auto', margin: [3, 0, 0, 0] }
                                ]
                            }
                        ]
                    },
                    {
                        width: '19%',
                        stack: [
                            {
                                columns: [
                                    createCheckbox(mergedData.parentsStatus === 'MOTHER_DECEASED', 6),
                                    { text: ' มารดาถึงแก่กรรม', style: 'text', width: 'auto', margin: [3, 0, 0, 0] }
                                ]
                            }
                        ]
                    },
                    {
                        width: '20%',
                        stack: [
                            {
                                columns: [
                                    createCheckbox(mergedData.parentsStatus === 'DECEASED', 6),
                                    { text: ' บิดาและมารดาถึงแก่กรรม', style: 'text', width: 'auto', margin: [3, 0, 0, 0] }
                                ]
                            }
                        ]
                    },
                  ],
                margin: [12, 0, 0, 5]
            },

            // Section 4: Guardian Information
            {
                text: '4. นักเรียนผู้สมัครมีผู้ดูแลเรียนอยู่โรงเรียน ภ.ป.ร. ราชวิทยาลัย ในพระบรมราชูปถัมภ์ หรือไม่',
                style: 'sectionHeader',
                margin: [0, 0, 0, 10]
            },

            {
                columns: [
                    {
                        width: '8%',
                        margin: [0, -10, 0, 0],
                        stack: [
                            {
                                columns: [
                                    createCheckbox(!mergedData.hasSibling, 5),
                                    { text: ' ไม่มี', style: 'text', width: 'auto', margin: [3, 0, 0, 0] }
                                ]
                            }
                        ]
                    },
                    {
                        width: '8%',
                        margin: [0, -10, 0, 0],
                        stack: [
                            {
                                columns: [
                                    createCheckbox(mergedData.hasSibling, 5),
                                    { text: ' มี', style: 'text', width: 'auto', margin: [3, 0, 0, 0] }
                                ]
                            }
                        ]
                    },
                    {
                        width: '84%',
                        margin: [0, -10, 0, 0],
                        columns: [
                            { text: 'ชื่อ ', style: 'label', width: 'auto' },
                            createField(mergedData.siblingName, 100, 'center'),
                            { text: ' สกุล ', style: 'label', width: 'auto' },
                            createField(mergedData.siblingLastName, 100, 'center'),
                            { text: ' ชั้น ', style: 'label', width: 'auto' },
                            createField(mergedData.siblingGrade, 70, 'center'),
                            { text: ' บ้าน ', style: 'label', width: 'auto' },
                            createField(mergedData.siblingHouse, 100, 'center')
                        ]
                    }
                ],
                margin: [15, 0, 0, 0]
            },

            {
                margin: [0, 5, 5, 0],
                text: [
                    { text: 'ลงชื่อ ', style: 'label' },
                    { text: '..............................' },
                    { text: ' ผู้สมัครสอบ', style: 'label' }
                ],
                alignment: 'right'
            },

            {
                margin: [0, 0, 0, 5],
                text: [
                    {
                        text: 'เจ้าหน้าที่ตรวจหลักฐานการรับสมัคร ',
                        style: 'smallUnderline'
                    },
                    {
                        text: 'ได้ตรวจหลักฐานาของผู้สมัครถูกต้องแล้ว ดังนี้',
                        style: 'smallText'
                    }
                ]
            },
            {
                margin: [12, 0, 0, 6],
                columns: [
                    {
                        width: '50%',
                        stack: [
                            {
                                columns: [
                                    createCheckbox(mergedData.checkDoc1),
                                    {
                                        text: 'ใบสมัครของโรงเรียน ภ.ป.ร. ราชวิทยาลัย ในพระบรมราชูปถัมภ์',
                                        margin: [5, -3, 0, 0],
                                        style: 'smallText'
                                    }
                                ],
                                margin: [0, 0, 0, 3]
                            },
                            {
                                columns: [
                                    createCheckbox(mergedData.checkDoc2),
                                    {
                                        text: `ใบรับรองกำลังศึกษาขั้นประถมศึกษาปีที่ ${mergedData.currentGrade} ปีการศึกษา ${mergedData.examYear - 1}`,
                                        margin: [5, -3, 0, 0],
                                        style: 'smallText'
                                    }
                                ],
                                margin: [0, 0, 0, 3]
                            },
                            {
                                columns: [
                                    createCheckbox(mergedData.checkDoc3),
                                    {
                                        text: `ใบแสดงผลการเรียนเฉลี่ย ชั้นประถมศึกษาปีที่ ${mergedData.currentGrade == 4 ? '3' : '4 และ 5'}\nไม่ต่ำกว่า 2.50 โดยผู้อำนวยการโรงเรียนรับรอง`,
                                        margin: [5, -3, 0, 0],
                                        style: 'smallText'
                                    },
                                ],
                                margin: [0, 0, 0, 3]
                            },
                        ]
                    },
                    {
                        width: '50%',
                        stack: [
                            {
                                columns: [
                                    createCheckbox(mergedData.checkDoc4),
                                    {
                                        text: 'ใบรับรองแพทย์จากสถานพยาบาลของรัฐหรือเอกชน',
                                        margin: [5, -3, 0, 0],
                                        style: 'smallText'
                                    }
                                ]
                            },
                            {
                                columns: [
                                    createCheckbox(mergedData.checkDoc5),
                                    {
                                        text: 'รูปถ่ายเครื่องแบบนักเรียน ขนาด 1 นิ้ว ที่มีรูปแบบเดียวกัน และถ่ายมาแล้วไม่เกิน 6 เดือน',
                                        margin: [5, -3, 0, 0],
                                        style: 'smallText'
                                    }
                                ],
                                margin: [0, 0, 0, 3]
                            },
                            {
                                columns: [
                                    createCheckbox(mergedData.checkDoc6),
                                    {
                                        text: [
                                            {
                                                text: 'สำเนาทะเบียนบ้านนักเรียน จำนวน 1 ชุด',
                                                style: 'smallText'
                                            },
                                        ],
                                        margin: [5, -3, 0, 0]
                                    }
                                ],
                                margin: [0, 0, 0, 3]
                            }
                        ]
                    }
                ]
            },
            {
                margin: [0, 0, 5, 0],
                text: [
                    { text: 'ลงชื่อ ', style: 'smallText2' },
                    { text: '.................................................', style: 'smallText2' },
                    { text: ' เจ้าหน้าที่', style: 'smallText2' }
                ],
                alignment: 'right'
            },
            {
                text: '(.................................................)',
                style: 'smallText2',
                margin: [0, 0, 35, 0],
                alignment: 'right'
            },
            {
                text: [{ text: '............./................./..................' }],
                style: 'smallText2',
                margin: [0, 0, 39, 0],
                alignment: 'right'
            },

            // show/hide ticket
            ...(mergedData.isShowTicket
                ?   [
                        {
                            text: '...........................................................................................................................................................',
                            margin: [0, -12, 0, 0]
                        },

                        {
                            margin: [-15, -5, 0, 0],
                            columns: [
                                // Left Section
                                {
                                    width: '50%',
                                    table: {
                                        widths: ['*', 65],
                                        body: [
                                            [
                                                {
                                                    stack: [
                                                        {
                                                            text: 'โรงเรียน ภ.ป.ร. ราชวิทยาลัย ในพระบรมราชูปถัมภ์',
                                                            style: 'smallText2',
                                                            margin: [0, 0, 0, -3]
                                                        },
                                                        {
                                                            text: 'บัตรประจำตัวผู้เข้าสอบคัดเลือก',
                                                            style: 'smallText2',
                                                            margin: [0, 0, 0, -3]
                                                        },
                                                        {
                                                            columns: [
                                                                {
                                                                    text: `ขั้น${mergedData.examGrade} `,
                                                                    style: 'smallText2',
                                                                    width: 'auto'
                                                                },
                                                                {
                                                                    ...createField(mergedData.examGradeLevel, 25, 'center', 8),
                                                                    style: 'smallText2'
                                                                },
                                                                {
                                                                    text: ' ปีการศึกษา ',
                                                                    style: 'smallText2',
                                                                    width: 'auto',
                                                                    margin: [3, 0, 0, 0]
                                                                },
                                                                {
                                                                    ...createField(mergedData.examYear, 40, 'center', 8),
                                                                    style: 'smallText2'
                                                                }
                                                            ],
                                                            margin: [0, 3, 0, -4]
                                                        },
                                                        {
                                                            columns: [
                                                                { text: 'ชื่อ ', style: 'smallText2', width: 12 },
                                                                {
                                                                    ...createField(mergedData.studentName, 75, 'center', 8),
                                                                    style: 'smallText2'
                                                                },
                                                                {
                                                                    text: ' สกุล ',
                                                                    style: 'smallText2',
                                                                    width: 'auto',
                                                                    margin: [3, 0, 0, 0]
                                                                },
                                                                {
                                                                    ...createField(mergedData.lastName, 75, 'center', 8),
                                                                    style: 'smallText2'
                                                                }
                                                            ],
                                                            margin: [0, 3, 0, -4]
                                                        },
                                                        {
                                                            columns: [
                                                                { text: 'ห้องสอบ ', style: 'smallText2', width: 'auto' },
                                                                { ...createField('', 40, 'center', 8), style: 'smallText2' },
                                                                {
                                                                    text: ' เลขประจำตัวสอบ ',
                                                                    style: 'smallText2',
                                                                    width: 'auto',
                                                                    margin: [3, 0, 0, 0]
                                                                },
                                                                { ...createField('', 50, 'center', 8), style: 'smallText2' }
                                                            ],
                                                            margin: [0, 3, 0, -4]
                                                        },
                                                        {
                                                            columns: [
                                                                { text: 'สอบคัดเลือกวันที่ ', style: 'smallText2', width: 'auto' },
                                                                {
                                                                    ...createField(mergedData.examDate, 75, 'center', 8),
                                                                    style: 'smallText2'
                                                                },
                                                                { text: 'เวลา ', style: 'smallText2', width: 'auto' },
                                                                {
                                                                    ...createField(mergedData.examTime, 35, 'center', 8),
                                                                    style: 'smallText2'
                                                                }
                                                            ],
                                                            margin: [0, 3, 0, -4]
                                                        },
                                                        // {
                                                        //     columns: [],
                                                        //     margin: [0, 3, 0, -4]
                                                        // },
                                                        {
                                                            columns: [
                                                                {
                                                                    text: 'ลายมือชื่อผู้เข้าสอบ ',
                                                                    style: 'smallText2',
                                                                    width: 'auto'
                                                                },
                                                                { ...createField('', 120, 'center', 8), style: 'smallText2' }
                                                            ],
                                                            margin: [0, 3, 0, -4]
                                                        }
                                                    ],
                                                    margin: [5, 5, 5, 5]
                                                },
                                                mergedData.studentPhoto
                                                    ?   {
                                                            image: mergedData.studentPhoto,
                                                            width: 60,
                                                            height: 75,
                                                            margin: [5, 5, 5, 5]
                                                        }
                                                    :   {
                                                            canvas: [
                                                                {
                                                                    type: 'rect',
                                                                    x: 0,
                                                                    y: 0,
                                                                    w: 60,
                                                                    h: 75,
                                                                    lineWidth: 1,
                                                                    lineColor: 'black'
                                                                }
                                                            ],
                                                            margin: [5, 5, 5, 5]
                                                        }
                                            ]
                                        ]
                                    },
                                    layout: {
                                        hLineWidth: function (i, node) {
                                            return i === 0 || i === node.table.body.length ? 1 : 0
                                        },
                                        vLineWidth: function (i, node) {
                                            return i === 0 || i === node.table.widths.length ? 1 : 0
                                        }
                                    }
                                },
                                // Small gap
                                { width: 7, text: '' },
                                // Right Section
                                {
                                    width: '50%',
                                    table: {
                                        widths: ['*', 65],
                                        body: [
                                            [
                                                {
                                                    stack: [
                                                        {
                                                            text: 'โรงเรียน ภ.ป.ร. ราชวิทยาลัย ในพระบรมราชูปถัมภ์',
                                                            style: 'smallText2',
                                                            margin: [0, 0, 0, -3]
                                                        },
                                                        {
                                                            text: 'บัตรประจำตัวผู้เข้าสอบคัดเลือก',
                                                            style: 'smallText2',
                                                            margin: [0, 0, 0, -3]
                                                        },
                                                        {
                                                            columns: [
                                                                {
                                                                    text: `ขั้น${mergedData.examGrade} `,
                                                                    style: 'smallText2',
                                                                    width: 'auto'
                                                                },
                                                                {
                                                                    ...createField(mergedData.examGradeLevel, 25, 'center', 8),
                                                                    style: 'smallText2'
                                                                },
                                                                {
                                                                    text: ' ปีการศึกษา ',
                                                                    style: 'smallText2',
                                                                    width: 'auto',
                                                                    margin: [3, 0, 0, 0]
                                                                },
                                                                {
                                                                    ...createField(mergedData.examYear, 40, 'center', 8),
                                                                    style: 'smallText2'
                                                                }
                                                            ],
                                                            margin: [0, 3, 0, -4]
                                                        },
                                                        {
                                                            columns: [
                                                                { text: 'ชื่อ ', style: 'smallText2', width: 12 },
                                                                {
                                                                    ...createField(mergedData.studentName, 75, 'center', 8),
                                                                    style: 'smallText2'
                                                                },
                                                                {
                                                                    text: ' สกุล ',
                                                                    style: 'smallText2',
                                                                    width: 'auto',
                                                                    margin: [3, 0, 0, 0]
                                                                },
                                                                {
                                                                    ...createField(mergedData.lastName, 75, 'center', 8),
                                                                    style: 'smallText2'
                                                                }
                                                            ],
                                                            margin: [0, 3, 0, -4]
                                                        },
                                                        {
                                                            columns: [
                                                                { text: 'ห้องสอบ ', style: 'smallText2', width: 'auto' },
                                                                { ...createField('', 40, 'center', 8), style: 'smallText2' },
                                                                {
                                                                    text: ' เลขประจำตัวสอบ ',
                                                                    style: 'smallText2',
                                                                    width: 'auto',
                                                                    margin: [3, 0, 0, 0]
                                                                },
                                                                { ...createField('', 50, 'center', 8), style: 'smallText2' }
                                                            ],
                                                            margin: [0, 3, 0, -4]
                                                        },
                                                        {
                                                            columns: [
                                                                { text: 'สอบคัดเลือกวันที่ ', style: 'smallText2', width: 'auto' },
                                                                {
                                                                    ...createField(mergedData.examDate, 75, 'center', 8),
                                                                    style: 'smallText2'
                                                                },
                                                                { text: 'เวลา ', style: 'smallText2', width: 'auto' },
                                                                {
                                                                    ...createField(mergedData.examTime, 35, 'center', 8),
                                                                    style: 'smallText2'
                                                                }
                                                            ],
                                                            margin: [0, 3, 0, -4]
                                                        },
                                                        {
                                                            columns: [
                                                                {
                                                                    text: 'ลายมือชื่อผู้เข้าสอบ ',
                                                                    style: 'smallText2',
                                                                    width: 'auto'
                                                                },
                                                                { ...createField('', 120, 'center', 8), style: 'smallText2' }
                                                            ],
                                                            margin: [0, 3, 0, -4]
                                                        }
                                                    ],
                                                    margin: [5, 5, 5, 5]
                                                },
                                                mergedData.studentPhoto
                                                    ?   {
                                                            image: mergedData.studentPhoto,
                                                            width: 60,
                                                            height: 75,
                                                            margin: [5, 5, 5, 5]
                                                        }
                                                    :   {
                                                            canvas: [
                                                                {
                                                                    type: 'rect',
                                                                    x: 0,
                                                                    y: 0,
                                                                    w: 60,
                                                                    h: 75,
                                                                    lineWidth: 1,
                                                                    lineColor: 'black'
                                                                }
                                                            ],
                                                            margin: [5, 5, 5, 5]
                                                        }
                                            ]
                                        ]
                                    },
                                    layout: {
                                        hLineWidth: function (i, node) {
                                            return i === 0 || i === node.table.body.length ? 1 : 0
                                        },
                                        vLineWidth: function (i, node) {
                                            return i === 0 || i === node.table.widths.length ? 1 : 0
                                        }
                                    }
                                }
                            ]
                        }
                    ]
                : []
            ),
        ],

        styles: {
            documentTitle: {
                fontSize: 12,
                bold: true,
                font: 'THSarabunNew'
            },
            schoolName: {
                fontSize: 12,
                bold: true,
                font: 'THSarabunNew'
            },
            sectionHeader: {
                fontSize: 11,
                font: 'THSarabunNew'
            },
            label: {
                fontSize: 10,
                font: 'THSarabunNew'
            },
            fieldData: {
                fontSize: 10,
                font: 'THSarabunNew',
                bold: true
            },
            underline: {
                fontSize: 12,
                font: 'THSarabunNew',
                decoration: 'underline'
            },
            text: {
                fontSize: 10,
                font: 'THSarabunNew'
            },
            checkbox: {
                fontSize: 10,
                bold: true,
                font: 'THSarabunNew'
            },
            formInfo: {
                fontSize: 11,
                bold: true,
                font: 'THSarabunNew'
            },
            formInfoData: {
                fontSize: 11,
                bold: true,
                font: 'THSarabunNew',
                decoration: 'underline'
            },
            schoolSignature: {
                fontSize: 8,
                font: 'THSarabunNew'
            },
            emptyCell: {
                fontSize: 8,
                color: 'white'
            },
            smallText: {
                fontSize: 8
            },
            smallText2: {
                fontSize: 9
            },
            smallUnderline: {
                fontSize: 8,
                bold: true,
                decoration: 'underline'
            }
        }
    }

    return documentDefinition
}

export function downloadEnrollmentFormPDF(data, filename = 'enrollment_form.pdf') {
    const docDefinition = generateEnrollmentFormPDF(data);
    pdfMake.createPdf(docDefinition).download(filename);
}

export function getEnrollmentFormPDFBlob(data) {
    const docDefinition = generateEnrollmentFormPDF(data);
    return new Promise((resolve) => {
        pdfMake.createPdf(docDefinition).getBlob(resolve);
    })
}

export function previewEnrollmentFormPDF(data) {
    const docDefinition = generateEnrollmentFormPDF(data);
    pdfMake.createPdf(docDefinition).open();
}
